import { RitningPostFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';

import {
  BebyggelseobjektUtkastRitningPostRequest,
  BebyggelseobjektUtkastRitningPutRequest,
  GranskningResurs,
  HTTP_STATUS
} from 'models';

import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';
import dayjs from 'dayjs';

const UTKAST_URL = `bebyggelseobjekt/utkast`;

const toRitningFormData = (values: RitningPostFormValues): FormData => {
  const formData = new FormData();
  formData.append('titel', values.titel);
  formData.append('motivbeskrivning', values.motivbeskrivning);
  formData.append('vy', values.vy);
  formData.append('bildfil', values.bildfil || '');
  formData.append('tillkomstdatum', dayjs(values.tillkomstdatum).format('YYYY-MM-DD'));
  formData.append('licens', values.licens.toString());
  formData.append('licensinformation', values.licensinformation);
  formData.append('ritningstyp', values.ritningstyp);

  return formData;
};

export const dokumentationRitningSlice = bebyggelseApiRTK.injectEndpoints({
  endpoints: (build) => ({
    postRitning: build.mutation<GranskningResurs, BebyggelseobjektUtkastRitningPostRequest>({
      transformErrorResponse(baseQueryReturnValue) {
        return {
          ignoreHttpError: [HTTP_STATUS.BAD_REQUEST],
          ...baseQueryReturnValue
        };
      },
      query: ({ utkastId, ritningPost }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/ritning`,
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: toRitningFormData(ritningPost)
      })
    }),
    putRitning: build.mutation<GranskningResurs, BebyggelseobjektUtkastRitningPutRequest>({
      query: ({ utkastId, resursId, ritningPut }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/ritning/${resursId}`,
        method: 'PUT',
        headers: {
          Accept: 'application/json'
        },
        body: toRitningFormData(ritningPut)
      })
    })
  })
});

export const { usePostRitningMutation, usePutRitningMutation } = dokumentationRitningSlice;
